import { render } from "./funclist.vue?vue&type=template&id=378e933e&ts=true"
import script from "./funclist.vue?vue&type=script&lang=ts"
export * from "./funclist.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__